function AssignedServiceProvider({
  height = 50,
  number = '',
  primaryColor = 'rgb(46,125,50)',
  quadrantColor = '#2e7d32',
  quadrantGap = 6, // gap between quadrants (degrees)
  nonGenericTypeHidePointer = false,
  location,
}) {
  const svgNS = 'http://www.w3.org/2000/svg';

  const originalWidth = 284.998;

  const fullHeight = 389.077;
  const circleOnlyHeight = 281.262;

  const viewBoxHeight = nonGenericTypeHidePointer
    ? circleOnlyHeight
    : fullHeight;

  const width = (height * originalWidth) / viewBoxHeight;

  const svg = document.createElementNS(svgNS, 'svg');
  svg.setAttribute('xmlns', svgNS);
  svg.setAttribute('width', width);
  svg.setAttribute('height', height);
  svg.setAttribute(
    'viewBox',
    nonGenericTypeHidePointer
      ? `0 0 ${originalWidth} ${circleOnlyHeight}`
      : `0 0 ${originalWidth} ${fullHeight}`,
  );

  const createElement = (tag, attrs) => {
    const el = document.createElementNS(svgNS, tag);

    Object.entries(attrs).forEach(([k, v]) => {
      el.setAttribute(k, v);
    });

    return el;
  };

  // Convert polar coords → cartesian
  const polarToCartesian = (cx, cy, r, angle) => {
    const rad = ((angle - 90) * Math.PI) / 180;

    return {
      x: cx + r * Math.cos(rad),
      y: cy + r * Math.sin(rad),
    };
  };

  // Ring segment path
  const createArcSegment = (
    cx,
    cy,
    outerRadius,
    innerRadius,
    startAngle,
    endAngle,
  ) => {
    const p1 = polarToCartesian(cx, cy, outerRadius, endAngle);
    const p2 = polarToCartesian(cx, cy, outerRadius, startAngle);

    const p3 = polarToCartesian(cx, cy, innerRadius, startAngle);
    const p4 = polarToCartesian(cx, cy, innerRadius, endAngle);

    return `
      M ${p1.x} ${p1.y}
      A ${outerRadius} ${outerRadius} 0 0 0 ${p2.x} ${p2.y}
      L ${p3.x} ${p3.y}
      A ${innerRadius} ${innerRadius} 0 0 1 ${p4.x} ${p4.y}
      Z
    `;
  };

  // Pointer
  if (!nonGenericTypeHidePointer) {
    svg.appendChild(
      createElement('path', {
        d: 'M142.596 -389.1 L269.563 -200.307 L15.628 -200.307 L142.596 -389.1 Z',
        fill: primaryColor,
        transform: 'matrix(1,0,0,-1,0,0)',
      }),
    );
  }

  // Outer green
  svg.appendChild(
    createElement('ellipse', {
      cx: '142.595',
      cy: '141.473',
      rx: '139.789',
      ry: '139.789',
      fill: primaryColor,
    }),
  );

  // White border
  svg.appendChild(
    createElement('ellipse', {
      cx: '142.595',
      cy: '141.473',
      rx: '129.492',
      ry: '129.492',
      fill: '#fff',
    }),
  );

  // ----- Quadrants -----
  const centerX = 142.595;
  const centerY = 141.473;

  const outerRadius = 124.682;
  const innerRadius = 96.738;

  for (let i = 0; i < 4; i += 1) {
    const start = i * 90 + quadrantGap / 2;
    const end = (i + 1) * 90 - quadrantGap / 2;

    const arcsColor = quadrant => {
      switch (quadrant) {
        case 0:
          return location?.skills?.servicesIndustry
            ? primaryColor
            : quadrantColor;
        case 1:
          return location?.skills?.servicesProductLine
            ? primaryColor
            : quadrantColor;
        case 2:
          return location?.skills?.servicesBrand ? primaryColor : quadrantColor;
        case 3:
          return location?.skills?.withinTravelDistance
            ? primaryColor
            : quadrantColor;
        default:
          return quadrantColor;
      }
    };

    svg.appendChild(
      createElement('path', {
        d: createArcSegment(
          centerX,
          centerY,
          outerRadius,
          innerRadius,
          start,
          end,
        ),
        fill: arcsColor(i),
      }),
    );
  }

  // Inner white circle
  svg.appendChild(
    createElement('ellipse', {
      cx: '142.595',
      cy: '141.473',
      rx: '96.738',
      ry: '96.738',
      fill: '#fff',
    }),
  );

  // pushpin
  svg.appendChild(
    createElement('path', {
      d: 'M49.5,15.4L36,1.9c-1.4-1.4-3.6-1.4-5,0s-1.4,3.6,0,5l0.7,0.7L15.5,18.3L15,17.8c-1.4-1.4-3.6-1.4-5,0 s-1.4,3.6,0,5l7.2,7.2L2.4,44.8c-1.4,1.4-1.4,3.7,0,5.1c1.4,1.4,3.7,1.4,5.1,0L22.3,35l6.3,6.3c1.4,1.4,3.6,1.4,5,0 c1.4-1.4,1.4-3.6,0-5l-0.5-0.5l10.6-16.3l0.7,0.7c1.4,1.4,3.6,1.4,5,0h0C50.8,19,50.8,16.8,49.5,15.4z',
      fill: primaryColor,
      transform: `
        translate(46 105)
        scale(1.5)
        rotate(-10)
      `,
    }),
  );

  const doubleDigit = (parseInt(number, 10) || 0) > 9;

  // Number
  const text = createElement('text', {
    x: doubleDigit ? '120' : '130',
    y: '170',
    fill: '#333',
    'font-family': 'Arial, sans-serif',
    'font-size': '93.2',
    'font-weight': '700',
  });

  text.textContent = parseInt(number, 10);
  svg.appendChild(text);

  return svg;
}

export default AssignedServiceProvider;
